import {
  SetupChecklistState,
  useSetupChecklistDisplayItems,
} from 'features/setup-checklist';
import React, { useCallback, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { SetupChecklistCard } from 'shared/components/ui/setup-checklist-card';

export type SetupChecklistContentProps = {
  state: SetupChecklistState;
};

export const SetupChecklistContent: React.FC<SetupChecklistContentProps> = ({
  state,
}) => {
  const { t } = useTranslation();
  const { displayItems, completeCount, totalCount, allComplete } =
    useSetupChecklistDisplayItems();

  const onHide = useCallback(() => state.dismiss(), [state]);
  const onToggleCollapse = useCallback(
    () => state.setCollapsed(!state.collapsed),
    [state],
  );

  useEffect(() => {
    if (allComplete && !state.everComplete) {
      state.markComplete();
    }
  }, [allComplete, state]);

  return (
    <SetupChecklistCard
      title={t('setup-checklist.title')}
      items={displayItems}
      completeCount={completeCount}
      totalCount={totalCount}
      collapsed={state.collapsed}
      onToggleCollapse={onToggleCollapse}
      onHide={onHide}
      hideLabel={t('setup-checklist.remove')}
    />
  );
};
